import React,{createContext,useState} from "react";

export const LangContext= createContext();

const LangContextProvider = (props)=>{
    const [activeLang,setActiveLang] = useState("English");

    return (
        <LangContext.Provider value={{activeLang,setActiveLang}}>
            {props.children}
        </LangContext.Provider>
    )
};

export default LangContextProvider;
